import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ish-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MaintenancePageComponent {}
